(function() {
"use strict";

setTimeout(function() {
  if (isIE()) {
    handleLoad();
  }
}, 500);


function handleLoad() {
  var modal = document.createElement("div");

  /*

  modal.innerHTML = `
    <style>
      .b-i-a {
        margin-right: 10px;
      }

      .b-i-a:hover {
        opacity: .5;
      }

      .d-b-ani {
        animation: d-b-ani 1s;
      }

      @keyframes d-b-ani {
        0% {
          opacity: 0;
          transform: translateY(-100%);
        }
      }
    </style>
    <div class="d-b-ani" style="top: 20px; left: 20px; right: 20px; padding: 20px; position: fixed; background: white; border: 2px solid #0099cc; z-index: 999; text-align: left;">
      <button type="button" class="new-close" style="position: absolute; right: 10px; top: 20px; border: none; color: #0099cc; cursor: pointer; background: transparent">close</button>

      <h1 style="margin-top: 0">Your browser is no longer supported.</h1>
      <h2>To continue using Any.do please open it in a more modern browser such as:</h2>

      <a target="_blank" rel="noopener noreferrer" href="https://www.mozilla.org/en-US/firefox/download/thanks/" class="b-i-a">
        <img width="64" height="64" src="/images/browsers-icons/firefox_128x128.png">
      </a>
      <a target="_blank" rel="noopener noreferrer" href="https://www.google.com/chrome/" class="b-i-a">
        <img width="64" height="64" src="/images/browsers-icons/chrome_128x128.png">
      </a>
      <a target="_blank" rel="noopener noreferrer" href="https://brave.com/" class="b-i-a">
        <img width="64" height="64" src="/images/browsers-icons/brave_128x128.png">
      </a>
      <a target="_blank" rel="noopener noreferrer" href="https://www.opera.com/" class="b-i-a">
        <img width="64" height="64" src="/images/browsers-icons/opera_128x128.png">
      </a>
    </div>
  `;

  */

  modal.innerHTML = "\n    <style>\n      .b-i-a {\n        margin-right: 10px;\n      }\n\n      .b-i-a:hover {\n        opacity: .5;\n      }\n\n      .d-b-ani {\n        animation: d-b-ani 1s;\n      }\n\n      @keyframes d-b-ani {\n        0% {\n          opacity: 0;\n          transform: translateY(-100%);\n        }\n      }\n    </style>\n    <div class=\"d-b-ani\" style=\"top: 20px; left: 20px; right: 20px; padding: 20px; position: fixed; background: white; border: 2px solid #0099cc; z-index: 999; text-align: left;\">\n      <button type=\"button\" class=\"new-close\" style=\"position: absolute; right: 10px; top: 20px; border: none; color: #0099cc; cursor: pointer; background: transparent\">close</button>\n\n      <h1 style=\"margin-top: 0\">Your browser is no longer supported.</h1>\n      <h2>To continue using Any.do please open it in a more modern browser such as:</h2>\n\n      <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://www.mozilla.org/en-US/firefox/download/thanks/\" class=\"b-i-a\">\n        <img width=\"64\" height=\"64\" src=\"/images/browsers-icons/firefox_128x128.png\">\n      </a>\n      <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://www.google.com/chrome/\" class=\"b-i-a\">\n        <img width=\"64\" height=\"64\" src=\"/images/browsers-icons/chrome_128x128.png\">\n      </a>\n      <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://brave.com/\" class=\"b-i-a\">\n        <img width=\"64\" height=\"64\" src=\"/images/browsers-icons/brave_128x128.png\">\n      </a>\n      <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://www.opera.com/\" class=\"b-i-a\">\n        <img width=\"64\" height=\"64\" src=\"/images/browsers-icons/opera_128x128.png\">\n      </a>\n    </div>\n  ";

  modal.querySelector(".new-close").onclick = function() {
    document.body.removeChild(modal);
  }


  document.body.appendChild(modal);

}

function isIE() {
  return !testCSSVariables();
}


function testCSSVariables() {
 var color = 'rgb(255, 198, 0)';
 var el = document.createElement('span');

 el.style.setProperty('--color', color);
 el.style.setProperty('background', 'var(--color)');
 document.body.appendChild(el);

 var styles = getComputedStyle(el);
 var doesSupport = styles.backgroundColor === color;
 document.body.removeChild(el);
 return doesSupport;
}
}());
